export default "__VITE_ASSET__gRzpF_yo__"